import { IonIcon, IonInput, IonRow } from "@ionic/react";
import { eye, eyeOff, eyeOffOutline, eyeOutline } from "ionicons/icons";
import { useRef, useState, Ref, FormEventHandler } from "react";
import {AutocompleteTypes} from '@ionic/core';
import React from "react";
import Input from "./Input";
import styled from 'styled-components';

interface PasswordInputProps {
	onChange: Function,
	placeholder: string,
	onInput?: FormEventHandler<HTMLIonInputElement>,
	password: string
	name: string
	autocomplete?: string
}

const PasswordInput = React.forwardRef(({
	onChange,
	placeholder,
	onInput,
	password,
	name,
	autocomplete
}: PasswordInputProps, ref: Ref<HTMLIonInputElement>) => {
	const [showPassword, setShowPassword] = useState(false);
	return (
		<IonRow className="ion-justify-content-between ion-align-items-center full-width">
			<Input
				ref={ref}
				color="constant-dark"
				type={(showPassword) ? 'text':'password'}
				onInput={onInput}
				onIonChange={(e: any) => {
					onChange(e.detail.value as string);
				}}
				placeholder={placeholder}
				name={name}
				value={password}
				autocomplete={autocomplete as AutocompleteTypes}
			/>
			<StyledIonIcon
				color="constant-light"
				icon={(showPassword) ? eyeOff:eye}
				onClick={() => setShowPassword(!showPassword)}
			/>
		</IonRow>
	);
});

export default PasswordInput;

const StyledIonIcon = styled(IonIcon)`
	font-size: 25px;
	position: absolute;
	right: 10px;
	z-index: 999;
`;